var packageJson = require('../package.json');

const packageVersion = packageJson.version;

export {
    packageVersion
}
